export enum SidebarMenu {
  NONE = 'none',
  HOME = 'home',
  STATISTICS = 'statistics',
  HEALTH_MONITOR = 'healthMonitor',
  USER = 'user',
  CASH_REGISTER = 'cashRegister',
}
